<template>
  <div class="sidebar-logo-container" :class="{ 'collapse': collapse }" :style="{ backgroundColor: sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground }">
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <div v-if="mini_logo"  class="sidebar-title">

        </div>
<!--        <img v-if="mini_logo" :src="mini_logo" class="sidebar-logo"/>-->
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
<!--        <img v-if="full_logo" :src="full_logo" class="sidebar-logo" />-->
        <div v-if="full_logo" class="sidebar-title">
          监测平台
        </div>
      </router-link>
    </transition>
  </div>
</template>

<script setup>
import variables from '@/assets/styles/variables.module.scss'
import logo from '@/assets/logo/logo.png'
import img from '@/assets/logo/img.png'
import full_logo from '@/assets/logo/full_logo.png'
import mini_logo from '@/assets/logo/mini_logo.png'
import useSettingsStore from '@/store/modules/settings'

defineProps({
  collapse: {
    type: Boolean,
    required: true
  }
})

const settingsStore = useSettingsStore();
const sideTheme = computed(() => settingsStore.sideTheme);
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: calc(100px - 4px);
  line-height: calc(100px - 4px);
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      height: 45px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 800;
      line-height: 50px;
      font-size: 25px;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      height: 40px;
      margin-right: 0;
    }
  }
}
</style>